<template>
  <div class="l-content">
    <div class="row">
      <!-- <div class="col-xs-16 col-xs-offset-1"> -->
      <div class="col-xs-18 col-sm-16 col-sm-offset-1">
        <figure>
          <!-- <img :src="src" :alt="alt"> -->
          <slot/>
          <figcaption v-if="caption" v-html="caption"></figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageFull',
  props: {
    caption: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/mixins';
figure {
  margin: 0;
  img {
    width: 100%;
    height: auto;
    box-shadow: 0 18px 28px 0 rgba(0,0,0,.04);
  }
  figcaption {
    color: $darker-grey;
    font-weight: 300;
    font-size: px2rem(13);
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImageFull.vue